<template>

    <v-container grid-list-sm text-xs-left>

        <v-layout row wrap align-center>
            <v-flex xs12 md6>

                <font size="7">{{getElementName(getCategoryFromPath(), homePageTopics)}}</font>
                <br/><br/>
                <font size="4">
                {{getElementDescription(getCategoryFromPath(), homePageTopics)}}
                </font>
                <br/><br/>


            </v-flex>
            <v-flex xs12 md6>
                <v-img
                        :src="getElementById(getCategoryFromPath(), homePageTopics).img"
                        aspect-ratio="1"
                        max-height="500"
                        contain
                ></v-img>
            </v-flex>
        </v-layout>

        <v-container grid-list-sm text-xs-center>
            <font size="7">Capabilities</font>
            <br/>
        </v-container>


        <v-layout row wrap text-xs-center>

            <v-flex v-for="homePageTopic in getElementById(getCategoryFromPath(), homePageTopics).children"
                    :key="homePageTopic.id"
                    xs12 sm6 md6 lg4 xl4
                    pa-4
            >
                <v-card
                        flat
                        color="transparent"
                >

                    <img
                            class="justify-center"
                            :src="homePageTopic.img"
                            :lazy-src="homePageTopic.img"
                            height="100px"
                    />
                    <v-card-title class="justify-center"
                            primary-title
                            flat
                            tile
                    >

                        <div >
                            <div class="headline">
                                {{ getLocalization(homePageTopic.name) }}
                            </div>
                            <span class="grey--text">{{ getLocalization(homePageTopic.description) }}</span>
                        </div>
                    </v-card-title>
                    <v-card-actions class="justify-center">
                        <v-btn
                                slot="activator"
                                color="blue"
                                round
                                outline
                                dark
                                class="elevation-0"
                                justify-center
                                @click="navigate(homePageTopic.goTo)"

                        >Explore
                        </v-btn>

                    </v-card-actions>


                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import LockedContent from "@/components/Decorator/LockedContent";
    import RouterService from "@/helpers/RouterService";
    import ServicesCategoriesInfo from "@/pages/Admin/ServicesCategories/ServicesCategoriesInfo";

    export default {
        name: "HomePageTypes",
        components: {
            LockedContent,
        },
        data() {
            return {
                homePageTopics: ServicesCategoriesInfo.homePageTopics

            }
        },
        methods: {


            navigate(path) {
                RouterService.goTo(path);
            },
            getLocalization(string){
                return this.$t(string);
            },
            getCategoryFromPath(){
                return this.$route.path.split('/')[this.$route.path.split('/').length -1];
            },

            getElementById(id, items) {
                //console.log('-----1----- in get element by id:'+id);

                if (!(typeof items === "undefined")){
                    //console.log('-----2----- items len :'+items.length);
                    for (let i = 0; i < items.length; i++){

                        let item = items[i];

                        //console.log('in for id:'+item.id);
                        if (item.id == id){
                            //console.log('-----3----- item FOUND id:'+id);
                            return item;
                        }else if (!(typeof item.children === "undefined")) {
                            //console.log('-----3----- looking in CHILDREN with id: '+item.id);
                            this.getElementById(id, item.children);

                        }else{
                            //console.log('-----3----- no children for id: '+item.id);
                        }
                    }
                }else{
                    //console.log('-----ID----- NO ITEMS')
                }

                //console.log('-----ID----- no id found');
            },

            getElementName(id, items){
                let item = this.getElementById(id, items);
                return this.getLocalization(item.name);
            },
            getElementDescription(id, items){
                let item = this.getElementById(id, items);
                return this.getLocalization(item.description);
            }
        },
    }

</script>

